<template>
  <div class="NoTabcolumnTextActive" name="List5">
    <div class="indexContainer" style="padding-top: 0">
      <div class="productCenterMain">
        <el-row>
          <a href="javascript:void(0);" v-for="(item, index) in NoTabcolumnTextActiveList" :key="index" @click="rowClick(item, index)">
            <div class="newTextlist">
              <div class="title">
                <span>{{ item.date }}</span>
                <p>{{ item.year }}</p>
              </div>
              <div class="text">
                <p>{{ item.title }}</p>
                <p class="listText">{{ item.summary }}</p>
              </div>
            </div>
          </a>
        </el-row>
        <el-row class="activePaga">
          <a href="javascript:;" class="stylePaga" @click="handleCurrentChange(1)">{{ this.base.pageHome }}</a>
          <el-pagination style="margin-top:30px;" :page-size="pageSize" layout="prev, pager, next" :current-page.sync="currentPage" @current-change="handleCurrentChange" :total="total">
          </el-pagination>
          <a href="javascript:;" class="stylePaga" @click="handleCurrentChange(num)">{{ this.base.pageBack }}</a>
          <span>{{ this.pageItem[0] }}{{ total }}{{ this.pageItem[1] }}</span>
          <span>{{ currentPage }}/{{ num }}{{ this.pageItem[2] }}</span>
        </el-row>
      </div>
    </div>
    <!--视频弹窗-->
    <video-dialog ref="video" />
    <!--图片弹窗-->
    <pic-dialog ref="pic" />
  </div>
</template>
<script>
import { getPage, getPageByParentModule } from "@/api/inner.js";
import VideoDialog from "@/components/common/components/videoDialog";
import PicDialog from "@/components/common/components/picDialog";
import { filterTime } from "@/common/js/common.js";
export default {
  components: {
    VideoDialog,
    PicDialog
  },
  props: {
    newsData: {}
  },
  data() {
    return {
      num: 1,
      currentPage: 1,
      total: 0,
      pageSize: 6,
      NoTabcolumnTextActiveList: [],
      base: this.$store.getters.base,
      pageItem: ["共", "条", "页"]
    };
  },
  created() {
    this.getList();
    // this.base = JSON.parse(localStorage.getItem('base'))
    this.pageItem = this.base.pageItem.split("/");
  },
  watch: {
    $route() {
      this.getList();
    }
  },
  methods: {
    async getList() {
      let url = "";
      if (this.newsData.id === "all") {
        let obj = {
          moduleId: this.$route.query.id,
          languageId: this.newsData.languageId,
          page: {
            page: this.currentPage,
            size: this.pageSize
          }
        };
        url = getPageByParentModule(obj);
      } else {
        let obj = {
          moduleId: this.newsData.id,
          languageId: this.newsData.languageId,
          page: {
            page: this.currentPage,
            size: this.pageSize
          }
        };
        url = getPage(obj);
      }
      await url.then(res => {
        this.NoTabcolumnTextActiveList = res.data.list;
        for (let i of this.NoTabcolumnTextActiveList) {
          i.releaseTime = filterTime(i.releaseTime, "time");
          let arr = i.releaseTime.trim().split(" ");
          i.date = arr[0].split("-")[2];
          i.year = arr[0].split("-")[0] + "-" + arr[0].split("-")[1];
        }

        this.total = res.data.page.total;
        this.page = res.data.page.page;
        this.num = Math.ceil(res.data.page.total / res.data.page.size);
      });
    },
    handleData() {
      let data = [];
      for (let v of this.NoTabcolumnTextActiveList) {
        if (Number(v.type) === 1) {
          data.push(v);
        }
      }
      return data;
    },
    rowClick(row, index) {
      if (row.isLink && row.linkUrl) {
        window.open(row.linkUrl, "_blank");
        return;
      }
      if (Number(row.type) === 0) {
        let routerPath = this.$router.resolve({
          name: "ARTICLEDETAIL",
          query: {
            languageId: this.$route.query.languageId,
            model: this.$route.query.model,
            modelId: this.$route.query.id,
            level: this.$route.query.level,
            type: this.$route.query.type,
            id: row.id
          }
        });
        window.open(routerPath.href, "_blank");
      } else if (Number(row.type) === 1) {
        let item = this.handleData();
        this.$refs.pic.open(item, index);
      } else if (Number(row.type) === 2) {
        this.$refs.video.open(row);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.NoTabcolumnTextActive {
  .productCenterMain {
    // padding-top: 20px;
    .activePaga {
      width: 100%;
      .stylePaga {
        border: 1px solid #eee;
        background: #fff;
        display: inline-block;
        line-height: 36px;
        padding: 0 12px;
        font-size: 14px;
      }
      .stylePaga:hover {
        color: #fff;
        background: #d11a2e;
      }
      span {
        padding: 0 5px;
      }
      .el-pagination {
        display: inline-block;
        font-size: 14px;
        line-height: 36px;
      }
      /deep/.el-pagination .btn-next,
      /deep/.el-pagination .btn-prev {
        // background: #fff;
        // display: inline-block;
        // min-width:36px;
        border: 1px solid #eee;
        padding: 0;
        height: 36px;
        margin: 0 4px;
        i {
          display: inline-block;
          line-height: 36px;
          min-width: 36px;
        }
      }
      /deep/.el-pager li {
        line-height: 36px;
        font-size: 14px;
        background: #fff;
        border: 1px solid #eee;
        height: 36px;
        min-width: 36px;
        margin: 0 4px;
      }
      /deep/.el-pager li.active,
      /deep/.el-pager li:hover,
      /deep/.el-pagination .btn-next:hover,
      /deep/.el-pagination .btn-prev:hover {
        color: #fff;
        background: #d11a2e;
      }
    }
    .newTextlist {
      border-top: 1px solid #f1f1f1;
      padding: 15px;
      background: #f7f7f7;
      .title {
        background: #fff;
        border-radius: 4px;
        width: 80px;
        height: 80px;
        font-size: 24px;
        overflow: hidden;
        color: #d11a2e;
        box-sizing: border-box;
        font-weight: bold;
        text-align: center;
        padding-top: 12px;
        float: left;
        span {
          display: inline-block;
          width: 100%;
        }
        p {
          font-size: 16px;
          margin: 0;
          line-height: 30px;
          font-weight: normal;
          width: 100%;
        }
      }
      .text {
        font-size: 16px;
        margin: 0;
        line-height: 24px;
        text-align: left;
        box-sizing: border-box;
        height: 80px;
        flex: 1;
        padding-left: 10px;
        overflow: hidden;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 8px 0;
          width: 100%;
          display: block;
        }
        .listText {
          font-size: 14px;
          color: #808080;
          width: 100%;
          overflow: hidden; /*隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis;
        }
      }
    }
    .newTextlist:hover {
      .text {
        color: #d11a2e;
      }
    }
    .el-col:nth-child(1) .newTextlist,
    .el-col:nth-child(2) .newTextlist {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/item/list5.vue